const strategyMap = {
    /* Strategy 1: 加分钟 */
    minsToFixed: val => {
        return val+'分钟';
    },
    /* Strategy 2: 日期格式化 */
    dateFormat: (val,fmt) => {
        if(!val){
            return "NA";
        }
        let date = new Date(val);
        let ret;
        let opt = {
            "y+": date.getFullYear().toString(), // 年
            "M+": (date.getMonth() + 1).toString(), // 月
            "d+": date.getDate().toString(), // 日
            "h+": date.getHours().toString(), // 时
            "m+": date.getMinutes().toString(), // 分
            "s+": date.getSeconds().toString() // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            };
        };
        return fmt;
    },
    /* Strategy 3: 格式化空值 */
    isEmpty: val => {
        return val || 'NA';
    },

    /* 判断状态 */
    statusFilter: val => {
        switch (val) {
            case 1:
                return "open";
                break;
            case 0:
                return "close";
                break;
            default:
                break;
        }
    }
}

/* Context: 生成el表单 formatter */

const tableFormatter = function (type, rowKey,extra) {
    return function (row, column, cellValue, index) {
        return strategyMap[type](row[rowKey],extra)
    }
}
export {tableFormatter,strategyMap}